<template>
  <div class="container-fluid">
    <div class="row mb-5">
      <div class="col-8">
        <span class="display-4 col-12">{{ $t("COMMON.DETAILS") }}</span>
      </div>
      <div class="col-4 text-right">
        <base-button
          @click="openResellerInvoiceItemModal()"
          type="button"
          class="btn btn-sm btn-primary"
          v-if="resellerInvoice.status === INVOICE_STATUS_DRAFT"
        >
          <span class="btn-inner--icon"><i class="fas fa-plus"></i></span>
          {{ $t("RESELLER_INVOICES.ADD_RESELLER_INVOICE_ITEM") }}
        </base-button>
      </div>
    </div>

    <resellerInvoice-view-details-resellerInvoice-item-table
      :resellerInvoice="resellerInvoice"
      @onOpenResellerInvoiceItemModal="openResellerInvoiceItemModal"
    />

    <div class="row mb-5" v-if="resellerInvoice.pricing">
      <div class="col-6"></div>
      <div class="col-6">
        <dl class="row mb-0">
          <dt class="col-sm-6">{{ $t("COMMON.SUBTOTAL") }}</dt>
          <dd class="col-sm-6 text-right">
            {{ $formatCurrency(resellerInvoice.pricing.subtotal) }}
          </dd>
        </dl>

        <dl class="row mb-0" v-if="resellerInvoice.pricing.discounts.amount">
          <dt class="col-sm-6">{{ $t("COMMON.DISCOUNTS") }}</dt>
          <dd class="col-sm-6 text-right">
            {{ $formatCurrency(resellerInvoice.pricing.discounts.amount * -1) }}
          </dd>
          <!-- <div class="col-12">
            <dl
              class="row mb-0"
              v-for="(discount, index) in resellerInvoice.pricing.discounts
                .details"
              v-bind:key="index"
            >
              <dt class="col-sm-6 pl-5 text-muted">{{ $te(`COMMON.${discount.name}`) ? $t(`COMMON.${discount.name}`) : discount.name }}</dt>
              <dd class="col-sm-6 text-right text-muted">
                {{ $formatCurrency(discount.amount * -1) }}
              </dd>
            </dl>
          </div> -->
        </dl>

        <dl class="row mb-0" v-if="resellerInvoice.pricing.taxes.total">
          <dt class="col-sm-6">{{ $t("COMMON.TAXES") }}</dt>
          <dd class="col-sm-6 text-right">
            {{ $formatCurrency(resellerInvoice.pricing.taxes.total) }}
          </dd>
          <div class="col-12">
            <dl
              class="row mb-0"
              v-for="(tax, index) in resellerInvoice.pricing.taxes.details"
              v-bind:key="index"
            >
              <dt class="col-sm-6 pl-5 text-muted">{{ tax.name }}</dt>
              <dd class="col-sm-6 text-right text-muted">
                {{ $formatCurrency(tax.amount) }}
              </dd>
            </dl>
          </div>
        </dl>

        <dl class="row mb-0">
          <dt class="col-sm-6">{{ $t("COMMON.TOTAL") }}</dt>
          <dd class="col-sm-6 text-right">
            {{ $formatCurrency(resellerInvoice.pricing.total) }}
          </dd>
        </dl>
      </div>
    </div>

    <!-- Modal add slot -->
    <resellerInvoice-view-details-resellerInvoice-item-form
      :resellerInvoice="resellerInvoice"
      :resellerInvoiceItem="resellerInvoiceItem"
      :showModal="showModal"
      @onCloseResellerInvoiceItemModal="closeResellerInvoiceItemModal"
      @onSubmitResellerInvoiceItemForm="handleResellerInvoiceItemFormSubmit"
      @onDeleteResellerInvoiceItem="deleteResellerInvoiceItem"
    />
  </div>
</template>

<script>
import { Button, Tooltip } from "element-ui";
import { cloneDeep } from "lodash";
import formMixin from "@/mixins/form-mixin";
import {
  INVOICE_STATUS_CANCELED,
  INVOICE_STATUS_DRAFT,
} from "@/constants/invoices";
import ResellerInvoiceViewDetailsResellerInvoiceItemForm from "./ResellerInvoiceViewDetailsResellerInvoiceItemForm.vue";
import ResellerInvoiceViewDetailsResellerInvoiceItemTable from "./ResellerInvoiceViewDetailsResellerInvoiceItemTable.vue";
import defaultResellerInvoiceItem from "../defaultResellerInvoiceItem";

export default {
  name: "resellerInvoice-view-details",

  components: {
    ResellerInvoiceViewDetailsResellerInvoiceItemForm,
    ResellerInvoiceViewDetailsResellerInvoiceItemTable,
    [Tooltip.name]: Tooltip,
    [Button.name]: Button,
  },

  mixins: [formMixin],

  props: ["resellerInvoice"],

  data() {
    return {
      resellerInvoiceItem: cloneDeep(defaultResellerInvoiceItem),
      loading: false,
      showModal: false,
      INVOICE_STATUS_DRAFT: INVOICE_STATUS_DRAFT,
      INVOICE_STATUS_CANCELED: INVOICE_STATUS_CANCELED,
    };
  },

  computed: {},

  methods: {
    openResellerInvoiceItemModal(resellerInvoiceItem = null) {
      if (!resellerInvoiceItem) {
        this.resellerInvoiceItem = cloneDeep(defaultResellerInvoiceItem);
      } else {
        this.resellerInvoiceItem = cloneDeep(resellerInvoiceItem);
      }
      this.showModal = true;
    },

    closeResellerInvoiceItemModal() {
      this.showModal = false;
      this.loading = false;
    },

    handleResellerInvoiceItemFormSubmit(resellerInvoiceItemData) {
      if (!resellerInvoiceItemData.id) {
        this.addResellerInvoiceItem(resellerInvoiceItemData);
      } else {
        this.editResellerInvoiceItem(resellerInvoiceItemData);
      }
    },

    async addResellerInvoiceItem(resellerInvoiceItemData) {
      this.loading = true;
      try {
        resellerInvoiceItemData.resellerInvoice.id = this.resellerInvoice.id;

        await this.$store.dispatch(
          "resellerInvoiceItems/add",
          resellerInvoiceItemData
        );
        this.$emit("resellerInvoiceItemsUpdated", null);

        this.$notify({
          type: "success",
          message: this.$t("RESELLER_INVOICES.RESELLER_INVOICE_ITEM_ADDED"),
        });

        this.loading = false;
        this.showModal = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.setApiValidation(error.response.data.errors);
        this.loading = false;
      }
    },

    async editResellerInvoiceItem(resellerInvoiceItemData) {
      this.loading = true;
      try {
        await this.$store.dispatch(
          "resellerInvoiceItems/update",
          resellerInvoiceItemData
        );
        this.$emit("resellerInvoiceItemsUpdated", null);

        this.$notify({
          type: "success",
          message: this.$t("RESELLER_INVOICES.RESELLER_INVOICE_ITEM_EDITED"),
        });

        this.loading = false;
        this.showModal = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.setApiValidation(error.response.data.errors);
        this.loading = false;
      }
    },

    async deleteResellerInvoiceItem(id) {
      this.loading = true;
      try {
        await this.$store.dispatch("resellerInvoiceItems/destroy", id);
        this.$emit("resellerInvoiceItemsUpdated", null);

        this.$notify({
          type: "success",
          message: this.$t("RESELLER_INVOICES.RESELLER_INVOICE_ITEM_DELETED"),
        });

        this.loading = false;
        this.showModal = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.setApiValidation(error.response.data.errors);
        this.loading = false;
      }
    },
  },

  mounted() {},

  watch: {},
};
</script>
